import React from 'react';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import About_section from './About_section';

const About_Main_Page = () => {
    return (
        <div>
            <Header></Header>
            <About_section></About_section>
            <Footer></Footer>
        </div>
    );
};

export default About_Main_Page;